import {
	calculateRecentPeriodDates,
	formatDateForGraphQL
} from 'src/common/helpers/DateFormatHelper';
import { ConditionDateTime } from 'src/common/types/graphql.generated';

import { DateVariables } from './types';

export const buildDateVariables = (days: number): DateVariables => {
	const { today: todayDate, recentPeriodStart } = calculateRecentPeriodDates(days);

	return {
		days,
		days2n: days * 2,
		calculationDateFrom: {
			value: [formatDateForGraphQL(recentPeriodStart)]
		} as ConditionDateTime,
		calculationDateTo: {
			value: [formatDateForGraphQL(todayDate)]
		} as ConditionDateTime
	};
};
